export enum CmsArticleStatusesEnum {
    PUBLISHED = 'PUBLISHED',
    DRAFT = 'DRAFT',
}

export enum CmsCategoryCodeEnum {
    PARTNERS_PRODUCTS = 'produkti_partnerov',
    LEAD_PRODUCTS = 'produkti_dlya_formi_dobavleniya_lidov',
    LEAD_PRODUCTS_REFERRAL = 'produkti_dlya_referalnih_ssilok',
    KNOWLEDGE_BASE = 'baza_znanii_kartochki_produktov',
    PRODUCT_GROUP_KNOWLEDGE_BASE = 'baza_znanii_gruppi_produktov',
    MTS_BANK = 'umnii_biznes_udvaivaem_paketi',
    REFERRAL_URLS = 'referalnie_ssilki',
    PROMOTIONAL_CODE = 'sale',
    INFO_BANNERS = 'banners',
    REVIEWS_AGENTS = 'glavnaya_otzivi_nashih_agentov',
    MAIN_QUESTIONS = 'glavnaya_ostalis_voprosi',
    TARGET_AUDIENCE = 'glavnaya_komu_podoidet',
    POTENTIAL_PROFIT = 'glavnaya_potentsialnaya_pribil',
    UPPER_BLOCK = 'glavnaya_verhnii_blok',
    FILES = 'faili',
    MAIN_TOOLS = 'glavnaya_instrumenti_dlya_vas',
}

export enum CmsDirectoryCodeEnum {
    PRODUCT_GROUP = 'product_group',
    PRODUCT_GROUP_KNOWLEDGE_BASE = 'baza_znanii_gruppi_produktov',
}

export enum CmsProductSefUrlEnum {
    MTS_AGENTS = 'mts_agents',
}

export enum CmsTypeEnum {
    FILES = 'FILES',
}
